export default "__VITE_ASSET__DWwqYzBl__"